/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Sticky mobile add to cart */
if (window.innerWidth < 480) {
    var doc = document.documentElement;
    var stickyContainer = document.getElementById('addtocart_section');
    if(![false, 0, "", null, undefined, NaN].includes(stickyContainer)){

    var stickyContainerBottom = stickyContainer.getBoundingClientRect().bottom;
    var windowHeight = Math.max(doc.clientHeight, window.innerHeight || 0);
    var scrollPosition = stickyContainerBottom - windowHeight;
    stickyContainer.className = 'stick_to_bottom';
  
    var scrollFunction = function() {
        var scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
      if (scrollTop >= scrollPosition) {
        stickyContainer.className = 'unstick_to_bottom';
      } else {
        stickyContainer.className = 'stick_to_bottom'; 
      }
    }
  
    window.addEventListener('scroll', scrollFunction);
  }
}

/* Add custom extra sale price */
jQuery(document).ready(function($) {
  // Moved to boost-pfs-filter.js
    /*
  setTimeout(function() { 
    if($('.ProductItem__Label.Extra20').length){

        $('.ProductItem__Label.Extra20').closest('.ProductItem__Wrapper').addClass('extrasale20 extrasale');
        $('.extrasale20').each(function(){
            var currentsaleprice = $('.ProductItem__Price.Price.Price--highlight', this).text();
            var currentsaleprice = currentsaleprice.replace(' kr', '');
            var currentsaleprice = String(currentsaleprice).replace(/.(?=\d{3})/g, '')
            var currentsaleprice = String(currentsaleprice).replace(/\,/g, '.');

            var percentage = (currentsaleprice * 0.8);

            $('.ProductItem__Price.Price.Price--highlight', this).before('<div class="saveextra">' + percentage + 'kr</div>');

        });
    }

   
    }, 1000);

*/
   if($('.template-product .extra-20').length){
        var currentsaleprice = $('.template-product .ProductMeta__Price.Price.Price--highlight', this).text();
        var currentsaleprice = currentsaleprice.replace(' kr', '');
        var currentsaleprice = String(currentsaleprice).replace(/.(?=\d{3})/g, '')
        var currentsaleprice = String(currentsaleprice).replace(/\,/g, '.');
        var currentsaleprice = String(currentsaleprice).replace(/\.00/g, ''); 


     
        var percentage = (currentsaleprice * 0.8);
        var finalsaleprice = percentage.toFixed(2);
        var finalsaleprice = String(finalsaleprice).replace(/\.00/g, '');

        $('.template-product .ProductMeta__Price.Price.Price--highlight', this).before('<div class="saveextra ProductMeta__Price Price Price--highlight Text--subdued u-h4 ">' + finalsaleprice + ' kr</div>');
        $('.Product__Wrapper').addClass('extrasale20 extrasale ');

    }
});


/* Terms popup*/
var submit = document.querySelector('form button.Cart__Checkout'),
    terms = document.querySelector('[data-terms]'),
    popup = document.querySelector('.js-popup');

const accept = popup.querySelector('.js-accept')
const cancel = popup.querySelector('.js-cancel')

accept.addEventListener('click', () => {
    popup.classList.remove('open')
    terms.checked = true
    location.href = "/checkout"
})

cancel.addEventListener('click', () => {
    popup.classList.remove('open')
})

;(function () {
    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();

        document.cookie = name + "=" + value + "; " + expires + "; path=/"
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    let received = 0;
    let allProducts=[];

    function processData (data) {
      const products = JSON.parse(data);

      received += products.length;
      console.log(`----- Fetched ${ received } products so far.`);

      allProducts = [...allProducts, ...products];

      if (received == window.allProductsCount ) {
        localStorage.setItem('allProducts', JSON.stringify(allProducts)) // Save in localStorage
        window.products = allProducts;
        setCookie('linkedFetched', true, 7);  // cookie expires in 7 days
        if (window.isProductPage) loadLinked();
      }
      return products.length;
    }

    function fetchAllProducts() {
      let pagination = 1;
      let allProducts = [];

      fetch(`/collections/all?view=linked&page=1`)
      .then( (r) => r.text() )
      .then( data => {

        received = processData(data);

        if (received < window.allProductsCount ) {
          let requests = [];
          const lastPage = Math.ceil(allProductsCount / 250);
          for (let i=2; i<= lastPage; i++ ) {
            requests.push( fetch(`/collections/all?view=linked&page=${i}`) );
          }
          Promise.all( requests )
          .then( responses => Promise.all(responses.map(r => r.text() ) ))
          .then( texts => { texts.forEach(processData) });
        }
      });
    }

    // Fetch product if not saved already

    let stored = localStorage.getItem('allProducts');
    let loadRequired = false;
    if (getCookie('linkedFetched') &&  stored ) { 
      window.products = JSON.parse(stored);

      if (window.allProductsCount === window.products.length) {
        console.log('----- Product data loaded from local storage');
        if (window.isProductPage) loadLinked();
      } else loadRequired = true;
    } else loadRequired = true;

    if ( loadRequired ) {
      if( window.isProductPage ) {
        fetchAllProducts();
      } else {
        console.log("----- Delay product data load.");
        window.addEventListener('load', fetchAllProducts);
      }
    }


    function getSkuProduct(sku) {
        let skuColor, skuProduct, skuProductAChar = ""

        if ( sku === '' ) return;

        sku = sku.split('-')

        if(sku.length < 2) return

        skuColor = sku[1].split('_')[0]

        if(!skuColor) return 

        let splitColorCharacters = skuColor.split('')
        splitColorCharacters.forEach(c => {
            if (parseInt(c) || c == "0") {
                skuProductAChar += c
            }
        })

        return sku[0] + "-" + skuProductAChar
    }

    function getSkuColor(sku) {
        let skuColor = "", skuProduct, skuProductAChar = ""
        const reg = /[^A-Za-z]/g

        // get SKU piece including color
        skuParts = sku.split('-')
        skuParts.length > 1 ? sku = skuParts[2] : sku = skuParts[0]

        // some SKUs are structured wrong, so fix them
        sku = sku.split('_')[0]

        // remove all numbers/specials from color
        skuColor = sku

        // sku = sku.split('-')

        // let splitColorCharacters = sku[1].split('_')[0].split('')

        // splitColorCharacters.forEach(c => {
        //     if (!parseInt(c) || c !== "0") {
        //         skuColor += c
        //     }
        // })

        return skuColor
    }
   /* only on .COM site BoostPFS misses these ??? */
    window.getSkuProduct = getSkuProduct;
    window.getSkuColor = getSkuColor;

    // Listen for the event.
    function loadLinked() {
        let linkedContainer = document.querySelector('.product__linked'),
            sku = getSkuProduct(document.body.dataset.sku),
            prods = window.products;


        const linked = prods.filter(i => getSkuProduct(i.sku) === sku);

        if (linked.length <= 1 ) return;
        linked.forEach((l, i) => {
            let lSku = getSkuProduct(l.sku),
                prodHTML
                
            //console.log({sku: l.sku, color: getSkuColor(l.sku)})

            if (l.sku === document.body.dataset.sku) {
              prodHTML = '<div title="' + l.title + '" class="product__linked-item active swatch-' + getSkuColor(l.sku) + '"></div>'
            } else {
              prodHTML = '<a title="' + l.title + '" href="/products/' + l.handle + '" class="product__linked-item swatch-' + getSkuColor(l.sku) + '"></a>'
            }
            linkedContainer.insertAdjacentHTML('beforeend', prodHTML)
        })
    }
})();

/**
 * Sizeguide modal
 */

var sizeTrigger = document.querySelector('[data-size-trigger]')

if (sizeTrigger) {
    var close = document.querySelector('[data-size-close]')
    var sizeModal = document.querySelector('[data-size]')
    var outer = document.querySelector('[data-outer]')

    sizeTrigger.addEventListener('click', function (event) {
        document.documentElement.classList.add('no-scroll');
        sizeModal.classList.add('is-open')
    })

    close.addEventListener('click', function (event) {
        event.preventDefault();

        sizeModal.classList.remove('is-open')
        document.documentElement.classList.remove('no-scroll')
    })

    document.addEventListener('click', function (event) {
        if (!outer.contains(event.target) && event.target != sizeTrigger) {
            sizeModal.classList.remove('is-open')
            document.documentElement.classList.remove('no-scroll')
        }
    })
}

